jQuery(function($) {
  //set an id for bundle widget
  $('[data-location]').attr('id', 'bundle-widget');
  //scroll to bundle section
  $(".sticky").click(function(event) {
    $('html, body').animate({scrollTop: $('#bundle-widget').offset().top - 100 }, 'slow');
  });

  if ( $(window).width() > 767) {    
    $(window).on('resize scroll', function() {
      if ($('product-info').isInViewport()) {
          $(".section-cta-sticky").removeClass("active");
      } else {
          $(".section-cta-sticky").addClass("active");
      }
      //hide sticky cta when reaches footer
      if ($(document).height() <= ($(window).height() + $(window).scrollTop())) {
        $(".section-cta-sticky").removeClass("active");
      }
    }); 
  } else {
    //always show cta on mobile   
    $(".section-cta-sticky").addClass("active");
    //hide button when its clicked
    $(".sticky").click(function(event) {
      $(this).hide();
    });
  } //end if

  $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
  };//end function
});